import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { HttpClientModule } from '@angular/common/http';
import { MyApp } from './app.component';
import { IonicStorageModule } from '@ionic/storage';

import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { HolzsystemePage } from '../pages/holzsysteme/holzsysteme';
import { AluminiumsystemePage } from '../pages/aluminiumsysteme/aluminiumsysteme';
import { HolzalusystemePage } from '../pages/holzalusysteme/holzalusysteme';
import { KunststoffsystemePage } from '../pages/kunststoffsysteme/kunststoffsysteme';
import { FenstertypPage } from '../pages/fenstertyp/fenstertyp';
import { SystemPage } from '../pages/system/system';
import { TypeopenPage } from '../pages/typeopen/typeopen';
import { MassePage } from '../pages/masse/masse'; 
import { DekorPage } from '../pages/dekor/dekor';
import { ColorPage } from '../pages/color/color';
import { GriffePage } from '../pages/griffe/griffe';
import { GriffeTypPage } from '../pages/griffetyp/griffetyp';
import { VerglasungPage } from '../pages/verglasung/verglasung';
import { VerglasungtypePage } from '../pages/verglasungtype/verglasungtype'; 
import { SprossenPage } from '../pages/sprossen/sprossen';
import { SprossentypePage } from '../pages/sprossentype/sprossentype'; 
import { RahmenPage } from '../pages/rahmen/rahmen';
import { AufstellungPage } from '../pages/aufstellung/aufstellung';
import { QuickviewPage } from '../pages/quickview/quickview';
import { CartPage } from '../pages/cart/cart';

import { UserserviceProvider } from '../providers/userservice';
import { CartserviceProvider } from '../providers/cartservice';
import { AppConfig } from './app-config';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen'; 
  
@NgModule({ 
  declarations: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    SystemPage,
    HolzsystemePage,
    AluminiumsystemePage,
    HolzalusystemePage,
    KunststoffsystemePage,
    FenstertypPage, 
    TypeopenPage, 
    MassePage,
    DekorPage,
    ColorPage,
    GriffePage, 
    GriffeTypPage,
    VerglasungPage,
    VerglasungtypePage,
    SprossenPage,
    SprossentypePage,
    RahmenPage,
    AufstellungPage, 
    QuickviewPage,
    CartPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    SystemPage,
    HolzsystemePage,
    AluminiumsystemePage,
    HolzalusystemePage,
    KunststoffsystemePage,
    FenstertypPage,
    TypeopenPage,
    MassePage,
    DekorPage,
    ColorPage,
    GriffePage,
    GriffeTypPage,
    VerglasungPage,
    VerglasungtypePage,
    SprossenPage,
    SprossentypePage,
    RahmenPage,
    AufstellungPage,
    QuickviewPage,
    CartPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    UserserviceProvider,
    CartserviceProvider,
    AppConfig, 
    {provide: ErrorHandler, useClass: IonicErrorHandler},
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts